module.exports = __webpack_public_path__ + "static/media/logo_twitter.f963dcac.png";